import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import useScreenSize from "hoc/useScreenSize";
import Image from "next/legacy/image";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./apparel-component.module.scss";

export default function FilterableAttribute(props) {
  const {
    defaultValues, selectedValue, attribute, handleSectionClick, handleFilterClick,
    availableValues = [], title, scrollToSection, scrollSectionImg,
  } = props;
  const [isMobile] = useScreenSize();

  return (
    <>
      <div className={`${styles.size_select_row} m-t-10 m-b-20`}>
        <PAText
          fontSize={isMobile ? FONT_SIZE[3] : FONT_SIZE[2]}
          bold
        >
          {title}
        </PAText>

        <HideIf show={scrollToSection}>
          <div className={styles.size_chart_select} onClick={handleSectionClick}>
            <Image
              src={getRelativeImagePath(scrollSectionImg)}
              alt={scrollToSection}
              width={20}
              height={20}
            />
            <PAText
              fontSize={isMobile ? FONT_SIZE[1] : FONT_SIZE[2]}
              {...!isMobile && { bold: true }}
              className={styles.scroll_text}
            >
              {scrollToSection}
            </PAText>
          </div>
        </HideIf>

      </div>

      <div className={styles.size_container}>
        {defaultValues.map((currValue) => {
          const isProductAvailable = [...availableValues].includes(currValue);
          return (
            <div
              key={currValue}
              className={classNames(styles.size_box, styles.size_box_filterable_attribute, {
                [styles.selected_size]: selectedValue === currValue,
                [styles.size_not_available]: !isProductAvailable,
              })}
              onClick={() => handleFilterClick(attribute, currValue, isProductAvailable)}
            >
              {currValue}
            </div>
          );
        })}
      </div>
    </>
  );
}
